export default {
  init() {
    // Initialize menu
    $('.wrap.container:not(.module-stats,.module-groupstats) h3').each(function(){
      $(this).attr('id',encodeURI($(this).text()));
      $('.nav-primary').append('<a href="#' + encodeURI($(this).text()) + '">' + $(this).text() + '</a>');
    });
    $('.banner a.menu').click(function(){
      if($(window).scrollTop() < 118){
        $('html,body').animate({scrollTop:118}, 400, function(){
          $('.banner').addClass('nav-active');
          $('.banner a.menu').hide();
        });
      }else{
        $('.banner').addClass('nav-active');
        $(this).hide();
      }
      
      return false;
    });
    $('.banner a.brand').click(function(){
      $('html,body').animate({scrollTop:0}, 800);
      $('.nav-primary a.close').click();
      return false;
    });
    $('.nav-primary a').click(function(){
      $('.banner').removeClass('nav-active');
      $('.banner a.menu').show();

      if($(this).hasClass('close')) return false;
    });

    $('.module-companies .show-all').click(function(){
      $(this).remove();
      $('.module-companies .companies').addClass('show_all');
      return false;
    });

    // Initialize scroll arrow
    $(window).scroll(function(){
      if($(window).scrollTop() > 50) $('header').addClass('scrolled');
      else $('header').removeClass('scrolled');
    });

    $('header').click(function(e){
      if(e.offsetY > $(this)[0].offsetHeight){
        $('html,body').animate({scrollTop:$(window).height()}, 1200);
      }
    });

    // Initialize margins
    $('.module-video').each(function(){
      if($('video',this).height() > $(this).height()){
        //$('video',this).css('margin-top',-($('video',this).height() - $(this).height()) / 2);
      }
    });
    $('.projects-wrapper .project').each(function(){
      $('h4',this).css('margin-top',($(this).width() / 2) - ($('h4',this).height() / 2) - 30);
    });

    // Extra video triggers
    $('.module-video').click(function(){
      $('video',this)[0].paused ? $('video',this)[0].play() : $('video',this)[0].pause();
      $(this).toggleClass('playing');
    });

    // Counter animations
    $(window).scroll(function(){
      if($(window).scrollTop() + $(window).height() > $('.module-stats').offset().top + 350 && !$('.module-stats').hasClass('counted')){
        $('.module-stats').addClass('counted');
        $('.module-stats strong').each(function(){
          $(this).animate({'opacity':1},{duration:500,queue:false});
          if($(this).hasClass('counter')){
            $(this).prop('Counter',0).animate({Counter:$(this).text()},{duration:2750,queue:false,easing:'swing',step:function(n){
              $(this).text(Math.ceil(n));
            }});
          }
        });
      }
    });

    $(window).resize(function(){
      if($('.module-headline .content').height() + 240 < $(window).height()){
        $('header').addClass('has-sd');
      }else{
        $('header').removeClass('has-sd');
      }
    });
    $(window).resize();

    // Modal links
    $('.modal-link').click(function(){
      $('body').append('<div class="modal-page"></div>');
      $('.modal-page').animate({top:'10vh',opacity:1},'slow');
      $('header,main,footer').fadeOut('slow');
      $.ajax({url:$(this).attr('href'),success:function(r){
        $('.modal-page').addClass('loaded').html(r);
        $('.modal-page .close').click(function(){
          $('header,main,footer').fadeIn('slow');
          $('.modal-page').fadeOut('slow',function(){
            $('.modal-page').remove();
          });
        });
      }});
      return false;
    });

    // Intro module rotation
    $('.intro-rotations strong span:not(:first)').hide();
    setTimeout(function(){
      rotate_intro_text();
    },2500);
    function rotate_intro_text(){
      var next_vis = $('.intro-rotations strong span:visible').next().length > 0 ? $('.intro-rotations strong span:visible').next() : $('.intro-rotations strong span:first');
      $('.intro-rotations strong span:visible').fadeOut('slow',function(){
        next_vis.fadeIn('slow');
        setTimeout(function(){
          rotate_intro_text();
        },2500);
      });
    }

    // Footer contact selector
    $('.module-contact .locations a').click(function(){
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
      $('.module-contact .contact-set').hide();
      $('.module-contact .contact-set[data-location=' + $(this).data('location') + ']').show();
      return false;
    });
    $(document).ready(function(){
      $('.module-contact .locations a.active').click();
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js